import React, { useState, useRef } from "react";
import { Render, TooltipContent } from "../Widgets/Tooltip"
import classNames from "classnames";
import styles from "./Popover.module.scss";
import { ReactComponent as TooltipIcon } from "./ic_tooltip_i.svg";
import { ErrorIcon, NoticeIcon, InfoIcon, SuccessIcon } from "../../../icons/monochrome";

const DefaultTrigger = ({ isActive }) => {
    return <TooltipIcon className={classNames(styles[`info-button`], { [styles[`info-button-active`]]: isActive })}/>;
};

const ErrorTrigger = () => {
    return <ErrorIcon color="error"/>
}

const HighNoticeTrigger = () => {
    return <NoticeIcon color="error"/>
}

const NoticeTrigger = () => {
    return <NoticeIcon color="warning"/>
}

const InfoTrigger = () => {
    return <InfoIcon color="information"/>
}

const SuccessTrigger = () => {
    return <SuccessIcon color="success"/>
}

/**
 *
 children,
 contentClassName, contentStyle,
 className, style,
 triggerStyle, triggerClassName
 placement, (left, center (default), right)
 verticalPlacement, (top/up, center, bottom/down (default)),
 Content -> defaults to TooltipContent
 */
export default React.memo(({ contentClassName, contentStyle, className, style, triggerStyle, triggerClassName, children, Trigger: _Trigger, Content = TooltipContent, placement: horizontalPlacement = "center", verticalPlacement = "bottom" }) => {
    const ref = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);

    if(verticalPlacement === "up") {
        verticalPlacement = "top";
    } else if(verticalPlacement === "down") {
        verticalPlacement = "bottom";
    }

    let placementClassName = `${verticalPlacement}-${horizontalPlacement}`;

    if(verticalPlacement === "bottom" || verticalPlacement === "top") {
        if(horizontalPlacement === "right") {
            horizontalPlacement = "left";
        } else if(horizontalPlacement === "left") {
            horizontalPlacement = "right";
        }
    }

    let Trigger = _Trigger;
    if (!Trigger) {
        Trigger = DefaultTrigger;
    } else if (Trigger === "error") {
        Trigger = ErrorTrigger;
    } else if (Trigger === "urgent-notice") {
        Trigger = HighNoticeTrigger;
    } else if (Trigger === "notice") {
        Trigger = NoticeTrigger;
    } else if (Trigger === "info") {
        Trigger = InfoTrigger;
    } else if (Trigger === "success") {
        Trigger = SuccessTrigger;
    }


    return <span className={classNames(styles['trigger-wrapper'], triggerClassName)} style={triggerStyle} ref={ref} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
        <Trigger isActive={isActive}/>
        <Render onIsShowing={setIsActive} className={classNames(styles[placementClassName], className)} style={style} triggerRef={ref} isTriggerHovered={isHovered} horizontalPlacement={horizontalPlacement} verticalPlacement={verticalPlacement}>
            <Content className={contentClassName} style={contentStyle}>{children}</Content>
        </Render>
    </span>
});
